import React, { Component } from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

import Project from './Project';

const queryUserDashboardLayout = gql`
  query userDashboardLayout($userId: ID!, $projectId: ID!, $type: String!) {
    userDashboardLayout(userId: $userId, projectId: $projectId, type: $type) {
      project_id
      user_id
      type
      dashboard_preferences
    }
  }
`;

const updateUserDashboardPreferencesMutation = gql`
  mutation updateUserDashboardPreferences(
    $userId: ID!
    $projectId: ID!
    $type: String!
    $dashboardPreferences: JSON!
  ) {
    updateUserDashboardLayout(
      userId: $userId
      projectId: $projectId
      type: $type
      dashboardPreferences: $dashboardPreferences
    ) {
      project_id
      user_id
      type
      dashboard_preferences
    }
  }
`;

const withData = graphql(queryUserDashboardLayout, {
  options: ({ currentProjectId, user }) => ({
    variables: {
      userId: user.get('id'),
      projectId: currentProjectId,
      type: 'Dashboard',
    },
    fetchPolicy: 'network-only',
  }),
});

const withMutation = graphql(updateUserDashboardPreferencesMutation, {
  props: ({ mutate }) => ({
    updateUserDashboardPreferencesMutation: (
      userId,
      projectId,
      type,
      dashboardPreferences,
    ) => {
      return mutate({
        variables: { userId, projectId, type, dashboardPreferences },
        update: (prev, { data: { updateUserDashboardLayout } }) => {
          return {
            ...prev,
            userDashboardLayout: updateUserDashboardLayout,
          };
        },
      });
    },
  }),
});

@withMutation
@withData
export default class ProjectDefaultTabContainer extends Component {
  enableDashboardLayout = () => {
    const { projectUsers, user } = this.props;

    if (!projectUsers || !projectUsers.length || !user.size) {
      return false;
    }

    return projectUsers.findIndex(a => a.get('id') === user.get('id')) !== -1;
  };

  render() {
    const { project, data: { loading } } = this.props;

    if (!project || loading) return <div />;

    return (
      <Project
        {...this.props}
        enableDashboardLayout={this.enableDashboardLayout()}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Project/TaskHome/ProjectContainer.js